import api from '../services/api';
import { toast } from 'sonner';

const DOCUMENT_LABELS = {
  quote: 'quote / Angebot',
  estimate: 'estimate / Kostenvoranschlag',
  invoice: 'invoice / Rechnung',
  'service-note': 'service note / Einsatzauftrag',
};

export async function previewDocumentPdf(documentType, documentId, documentNumber) {
  const label = DOCUMENT_LABELS[documentType] || 'document / Dokument';
  const previewTab = window.open('about:blank', '_blank');

  if (!previewTab) {
    toast.error('Please allow pop-ups to open the PDF preview. / Bitte Pop-ups für die PDF-Vorschau erlauben.');
    return;
  }

  previewTab.opener = null;
  previewTab.document.title = `${documentNumber || label} – Preview`;
  previewTab.document.body.style.fontFamily = 'system-ui, sans-serif';
  previewTab.document.body.style.padding = '2rem';
  previewTab.document.body.textContent = 'Preparing PDF preview… / PDF-Vorschau wird erstellt…';

  try {
    const response = await api.get(`/${documentType}s/${documentId}/pdf`, {
      responseType: 'blob',
    });
    const pdf = new Blob([response.data], { type: 'application/pdf' });
    const previewUrl = window.URL.createObjectURL(pdf);
    previewTab.location.replace(previewUrl);
    window.setTimeout(() => window.URL.revokeObjectURL(previewUrl), 5 * 60 * 1000);
  } catch (error) {
    previewTab.close();
    toast.error(`Unable to preview ${label}. / Vorschau konnte nicht geöffnet werden.`);
  }
}
